export default "__VITE_ASSET__CMZZQym4__"